type Mode = 'light' | 'dark'

export interface ThemeInterface {
  mode: Mode
}
const mainFont =
  "Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif"
const codeFont = ' Consolas, Menlo, Courier, monospace'
const headingFont =
  "'Poppins', 'Roboto', 'Helvetica Neue For Number',sans-serif"

export const fonts = {
  main: mainFont,
  code: codeFont,
  heading: headingFont,
}

export const fontSize = {
  text: 15,
  smallText: 13,
  heading: 20,
  h1: 28,
  h2: 24,
  h3: 20,
  h4: 19,
  h5: 18,
  h6: 17,
}

export const colors = {
  white: '#fff',
  black: '#000',
  grayDarker: '#cbcbcb',

  borderColor1: '#EAECEE',
  borderColor2: '#F2F4F5',
  borderColor3: '#F6F9FA',

  textColor: '#47525E',
  textColorDark: '#47525E',
  textColorLight: '#7A8994',
  headingColor: '#373E43',

  primary: '#007BE8',
  primaryLight1: '#3395ED',
  primaryLight2: '#CCE5FA',
  primaryDark1: '#0064bd',
  primaryDark2: '#00529a',

  secondary: '#DADCDF',
  secondaryLight1: '#e1e5e6',
  secondaryLight2: '#f0f0f0',
  secondaryDark1: '#ccced2',
  secondaryDark2: '#b5b7bb',

  info: '#8bc34a',
  infoLight1: '#9ecb69',
  infoLight2: '#abd080',
  infoDark1: '#76a43f',
  infoDark2: '#668e37',

  danger: '#EA2C54',
  dangerLight1: '#fb5c7e',
  dangerLight2: '#ff829d',
  dangerDark1: '#d8133c',
  dangerDark2: '#ab1131',

  warning: '#FED76E',
  warningLight1: '#ffe08c',
  warningLight2: '#ffe5a0',
  warningDark1: '#e6bf55',
  warningDark2: '#c9a43f',

  disabledBg: '#ececec',
  disabledColor: '#b5b0b0',
  bodyBg: '#f5f3ef',
  darkBodyBg: '#272522',
  darkBodyBgLighter: '#3a3733',
}

export const padding = {
  xsmall: 5,
  small: 10,
  default: 15,
  large: 30,
  xlarge: 60,
}

export const borderRadius = {
  xsmall: 1,
  small: 2,
  default: 3,
  large: 10,
  xlarge: 20,
}

export const boxShadow = {
  default: '2px 2px 2px #e3e0d8',
}

export const focus = {
  default: `0 0 0px 3px ${colors.primaryLight1}`,
}

export const lightTheme: ThemeInterface = { mode: 'light' }
export const darkTheme: ThemeInterface = { mode: 'dark' }

export const theme = {
  colors,
  padding,
  fonts,
  fontSize,
  borderRadius,
  boxShadow,
  focus,
}
